<script>
	import { t } from '$lib/locales';
	import { onMount } from 'svelte';
	import themes from './themes';
	import { bq, restaurant, pageState, GbmMethods, RedirectToStep, steps } from './store';
	import { page } from '$app/stores';
	import { goto } from '$app/navigation';

	import Error from './components/Error.svelte';

	export let data;

	const DEFAULT_MIN_GROUP_SIZE = 17;
	const DEFAULT_MAX_GROUP_SIZE = 500;
	let ready = false;
	let fonts = ``;

	const getStyles = (node) => {
		for (const [key, value] of Object.entries(themes[data.theme])) {
			if (key === 'font-url') {
				fonts = `<link href="${value}" rel="stylesheet">`;
			}
			node.style.setProperty(`--${key}`, value);
		}
		setWidthValues();
	};

	const setWidthValues = () => {
		const values = { xs: 350, sm: 400, smd: 500, md: 600 };
		const width = window.innerWidth;
		for (const [key, value] of Object.entries(values)) {
			$pageState[key] = width < value;
		}
	};

	const handleRedirect = async () => {
		if (Object.keys(data.bq).length !== 0) {
			if (data.bq.hasOwnProperty('isFrom') && Object.keys(data.bq).length === 1) return;
			await goto(RedirectToStep[steps.party_size] + data.search);
		}
	};

	onMount(async () => {
		for (const [key, value] of Object.entries(data.bq)) {
			if (key === 'date') $bq.date = new Date(+value);
			else $bq[key] = value;
		}

		if ($bq.date) {
			$bq.time =
				$bq.date.getHours() + ':' + ($bq.date.getMinutes() === 0 ? '00' : $bq.date.getMinutes());
		}

		try {
			$restaurant = await GbmMethods.get(data.restaurantToken);
		} catch (err) {
			$pageState.isError = true;
			$pageState.error = err;
		}

		if (!$restaurant?.nbMinForGroup) $restaurant.nbMinForGroup = DEFAULT_MIN_GROUP_SIZE;
		if (!$restaurant?.nbMaxForGroup) $restaurant.nbMaxForGroup = DEFAULT_MAX_GROUP_SIZE;
		if (!$bq.nbPersons) $bq.nbPersons = $restaurant.nbMinForGroup;

		$pageState.shouldRedirect = false;
		await handleRedirect();
		ready = true;
	});
</script>

<svelte:window on:resize={setWidthValues} />

<svelte:head>
	{@html fonts}
</svelte:head>

{#if ready}
	<div data-cy="main" class="global-wrapper" use:getStyles>
		<div class="main">
			<div class="header">
				<h1>{$t('gbm.title')}</h1>
				{#if (!$pageState.smd && !$pageState.isError) || $page.data.step === steps.confirmation}
					<p data-cy="header-message">
						{#if $page.data.step === steps.date}
							{$t('gbm.sub_title', { restaurant: $restaurant.name })}
						{/if}
						{#if $page.data.step === steps.confirmation}
							{$pageState.isPro ? $t('gbm.confirm_pro') : $t('gbm.confirm')}
						{/if}
					</p>
				{/if}
			</div>
			<div class="content">
				{#if $pageState.isError}
					<Error error={$pageState.error} />
				{:else}
					<slot />
				{/if}
			</div>
		</div>
	</div>
{/if}

<style>
	:global(body, html) {
		margin: 0;
		--font-size: calc(16px + 0.3vw);
	}
	.global-wrapper {
		overflow-y: overlay;
		overflow-x: hidden;
		height: 100vh;
		width: 100vw;
		background-color: var(--background-color, #fff);
		display: grid;
		place-items: center;
		font-size: var(--font-size);
	}
	.global-wrapper * {
		font-family: var(--font-family, 'Barlow', sans-serif);
	}
	.main {
		height: 100%;
	}
	.header {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.content {
		padding-bottom: 20px;
		display: grid;
	}
	h1 {
		text-align: center;
		font-size: 1.5em;
		font-weight: 800;
		margin: 0.2em 0;
		color: var(--font-color, #000);
	}
	p {
		font-weight: 400;
		color: var(--font-color, #000);
		text-align: center;
		white-space: pre-line;
	}
</style>
